import React from 'react';
import styled from 'styled-components';
import ContactSection from '../components/sections/ContactSection';

const ContactPage = () => {
  return (
    <ContactPageContainer>
      <ContactSection />
    </ContactPageContainer>
  );
};

const ContactPageContainer = styled.div`
  padding-top: 2rem;
`;

export default ContactPage;